export const EXPOSURE_REPORT_CONTEXT_KEY = 'EXPOSURE_REPORT_CONTEXT_KEY'

export const EXPOSURE_TYPES = {
  ASSET: 'asset',
  CLASSIFICATION_TAG: 'classificationTag'
}

export const DATA_SET_TYPES = {
  BALANCE: 'balance',
  BALANCE_AND_PERFORMANCE: 'balanceAndPerformance'
}

export const EXPOSURE_TYPE_ID_KEY = {
  [EXPOSURE_TYPES.ASSET]: 'assetId',
  [EXPOSURE_TYPES.CLASSIFICATION_TAG]: 'classificationTagId'
}

export const getAssetExposureName = (exposureType, asset) => {
  if (exposureType === EXPOSURE_TYPES.ASSET) {
    return `${asset?.assetIdentifier} - ${asset?.longName}`
  }
  if (exposureType === EXPOSURE_TYPES.CLASSIFICATION_TAG) {
    return asset.longName
  }
  return null
}

export const levelDatesQuery = { levelType: 'user' }
